import { render, staticRenderFns } from "./yieldDetailTabsFour.vue?vue&type=template&id=7167958b&scoped=true&"
import script from "./yieldDetailTabsFour.vue?vue&type=script&lang=js&"
export * from "./yieldDetailTabsFour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7167958b",
  null
  
)

export default component.exports